module.exports = __webpack_public_path__ + "static/homepage-cloud-editor-aee45a8b925340d6dc2424a905d06678.mp4";